import { ArrowRight, PackageCheck, Plus } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api'
import { CustomerStatus } from '../components/CustomerStatus'
import { PageError, PageLoading } from '../components/PageState'
import { formatDate, money } from '../format'
import type { Dashboard, ForwardingOrder } from '../types'

export function CustomerDashboard(){
  const [data,setData]=useState<Dashboard|null>(null)
  const [error,setError]=useState('')
  const [visibleCount,setVisibleCount]=useState(12)
  useEffect(()=>{api<Dashboard>('/api/dashboard').then(setData).catch(e=>setError(e.message))},[])
  if(error)return <PageError message={error}/>
  if(!data)return <PageLoading/>
  const visibleOrders=data.orders.slice(0,visibleCount)
  return <div className="page page--customer orders-index">
    <header className="page-head"><div><div className="eyebrow"><span/> CUSTOMER ROUTE</div><h1>Your orders.</h1><p>Every quote, inbound package, and shipment lives in one place.</p></div><Link className="button button--primary" to="/inbounds/new"><Plus size={18}/>New forwarding order</Link></header>
    <section className="orders-ledger" aria-label="Forwarding orders">
      <header><span>Order</span><span>Route</span><span>Total</span><span>Status</span><span aria-hidden="true"/></header>
      {visibleOrders.length?visibleOrders.map(order=><OrderRow order={order} key={order.id}/>):<div className="orders-empty"><PackageCheck/><div><b>No orders yet.</b><p>Choose a product format and destination to see live shipping prices.</p></div><Link className="button button--primary" to="/inbounds/new">Get a forwarding quote <ArrowRight size={17}/></Link></div>}
      {data.orders.length>visibleCount&&<button className="orders-more" onClick={()=>setVisibleCount(count=>count+12)}>Show more orders <span>{visibleCount} of {data.orders.length}</span></button>}
    </section>
  </div>
}

function OrderRow({order}:{order:ForwardingOrder}){
  return <Link className="order-row" to={`/orders/${order.id}`}>
    <div className="order-row__identity"><div className="order-row__codes"><b>{order.publicId}</b>{order.rxid&&<span className="order-row__rxid">RXID {order.rxid}</span>}</div><span>{order.contentsSummary} · {formatDate(order.createdAt)}</span></div>
    <div className="order-row__route"><b>{order.destination.city}, {order.destination.countryCode}</b><span>{order.carrier&&order.service?`${order.carrier} · ${order.service}`:'Carrier selection pending'}</span></div>
    <strong>{order.price?money(order.price.totalMinor,order.price.currency):'—'}</strong>
    <CustomerStatus order={order}/><ArrowRight size={18}/>
  </Link>
}
